import React from 'react'
import { ContentCard } from '@components/ui/ContentCard'
import type { Publication } from '@data/types'

interface PublicationCardProps {
  publication: Publication
  showSocial?: boolean
}

export const PublicationCard: React.FC<PublicationCardProps> = ({
  publication,
  showSocial = false,
}) => {
  if (!publication.title) return null

  // internal if no link, otherwise external
  const internalLink = publication.link
    ? undefined
    : `/publications/${publication.slug}`

  return (
    <ContentCard
      id={publication.id}
      title={publication.title}
      description={publication.abstract}
      image={publication.image}
      date={publication.date}
      tags={publication.tags}
      internalLink={internalLink}
      externalLink={publication.link}
      categoryLabel={publication.type}
      journal={publication.journal}
      showSocial={showSocial}
    />
  )
}
